module.exports = __webpack_public_path__ + "img/saint-rita-of-cascia.f1d59f0e.jpg";